import React, { useEffect, useState } from "react";
import technologyy from "assets/img/technologyy.webp";
import juniorlogo1 from "assets/img/Juniorlogo1.png";
import googleicon from "assets/img/googleicon.png";
import toast from "react-hot-toast";
import axios from "axios";
import { useHistory } from "react-router";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const history = useHistory();

  const handleLogin = async () => {
    
    if (email.trim().length === 0) {

      toast.error("Enter Full Email");

    } else if (password.trim().length === 0) {

      toast.error("Enter Your Password");

    } else {
      
      try {
        const response = await axios.post("https://api.juniortoes.com/api/login", {
          email,
          password
        });
  
        if (response.status === 200) {
          localStorage.setItem("token", response.data.token);
          localStorage.setItem("user", JSON.stringify(response.data.user));
          
          toast.success("Login Successfull");
          history.push("/dashboard");

          // window.location.href = "/dashboard";

        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Something went wrong. Try again."
        );
      }
    }
  };
  

  return (
    <>
      <div
        className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 grid-cols-1 xl:h-screen lg:h-screen md:h-screen 
      "
      >
        {/* Left Section */}
        <div>
          <div>
            <img
              src={juniorlogo1}
              alt="Logo"
              className="xl:w-4/12 lg:w-4/12 md:w-4/12 w-6/12 pl-6 pt-6 lg:pl-6 lg:pt-8 xl:pl-8 xl:pt-8 xl:mb-10 lg:mb-12"
            />
          </div>

          <div className=" flex justify-center items-center bg-white xl:mt-0 lg:mt-0 md:mt-12 mt-16">
            <div className="xl:w-6/12 lg:w-6/12 md:w-8/12">
              <h1 className="xl:text-4xl lg:text-4xl md:text-3xl text-2xl text-black font-bold ">
                Welcome back
              </h1>
              <p className="xl:text-base text-base pt-1">
                Please enter your details
              </p>
              <form className="space-y-4 pt-8">
                <div>
                  <label className="block xl:text-base text-base lg:pt-6 pt-4 text-black xl:pt-6">
                    Email address
                  </label>
                  <input
                    type="email"
                    className="xl:w-12/12 w-12/12 borderform rounded mt-1 p-2 "
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div>
                  <label className="block xl:text-base text-base mt-4  text-black xl:mt-4">
                    Password
                  </label>
                  <input
                    type="password"
                    className="xl:w-12/12 w-12/12 borderform rounded mt-1 p-2"
                    placeholder="Enter your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
                <div className="flex justify-between items-center xl:mt-4 mt-4 gap-2">
                  <a
                    href="#"
                    className="xl:text-sm text-sm text-blue underline hover:underline"
                  >
                    Forgot password
                  </a>
                </div>
                <div>
                  <button
                    type="button"
                    onClick={handleLogin}
                    className="xl:w-12/12  w-12/12 lg:mt-6 md:mt-4 mt-4 background-blue text-white py-2 rounded xl:mt-6"
                  >
                    Sign in
                  </button>
                </div>
              </form>
              <p className="text-center text-sm text-gray-600 mt-6">
                Don’t have an account?{" "}
                <a href="#" className="text-blue underline hover:underline">
                  Sign up
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="xl:block lg:block md:hidden sm:hidden hidden">
          <div className="h-full xl:mt-0 lg:mt-0 md:mt-12 mt-8 ">
            <div className=" justify-center items-center">
              <div
                className="xl:h-screen lg:h-screen md:h-screen h-screen"
                style={{
                  backgroundImage: `url(${technologyy})`,
                  width: "100%",

                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
